import classNames from "classnames";
import React from "react";
import { Agency, AgencyId } from "../../../messages";
import { CaregiverStatus } from "../../../messages/CaregiverStatus";
import { formatPhone } from "../../../phone_number";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { withDefault } from "../../../utils/withDefault";
import { AppButton } from "../../Generic/AppButton";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import AsyncImage from "../../Generic/AsyncImage";
import Flex from "../../Generic/Flex";
import { If } from "../../Generic/If";
import { IsDefined } from "../../Generic/IsDefined";
import { AgencyBlock } from "../AgenciesListUtils";

const AGENCY_LOGO_PLACEHOLDER = "./assets/agency_logo.png";

interface Props {
  agency: AgencyBlock;
  status: CaregiverStatus;
  className?: string;
  hidden?: boolean;
  onClickChatWithAgency: (agencyId: Agency) => void;
  onClickCancel: (agencyId: AgencyId) => void;
}

const ChatWithAgencyCard = (props: Props) => {
  const agencySrc = withDefault(props.agency.agencyDetails.logoUrl, AGENCY_LOGO_PLACEHOLDER);

  const handleClickChatWithAgency = React.useCallback(() => {
    return props.onClickChatWithAgency.call(null, props.agency.agencyDetails);
  }, [props.onClickChatWithAgency, props.agency.agencyDetails]);

  const handleClickCancel = React.useCallback(() => {
    return props.onClickCancel.call(null, props.agency.agencyDetails.id);
  }, [props.onClickCancel, props.agency.agencyDetails.id]);

  const ivrPhoneNumbers = props.agency.agencyDetails.ivrPhoneNumbers;

  return (
    <AppCard className={classNames("ChatWithAgencyCard", props.className)} hidden={props.hidden}>
      <AppCardContent>
        <If condition={props.status === "JOIN_REQUEST"}>
          <div onClick={handleClickCancel} className={"AgenciesList__X"} />
        </If>

        <Flex className="__agency-details" alignItems="center" xGap={16}>
          <AsyncImage src={agencySrc} className="__agency-avatar" />
          <span>
            <strong className="__agency-name">{props.agency.agencyDetails.name}</strong>

            <IsDefined value={ivrPhoneNumbers}>
              {(_ivrPhoneNumbers) => (
                <div className="__agency-ivr">
                  IVR:{" "}
                  {_ivrPhoneNumbers.map((ivrPhone) => {
                    return (
                      <div key={ivrPhone.ivrPhoneNumber}>
                        {formatPhone(ivrPhone.ivrPhoneNumber)} {ivrPhone.description}
                      </div>
                    );
                  })}
                </div>
              )}
            </IsDefined>
          </span>
        </Flex>

        <AppButton onClick={handleClickChatWithAgency} variant="outline">
          {translate(STRINGS.CHAT_WITH_AGENCY)}
        </AppButton>
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(ChatWithAgencyCard);
